import React, { createContext, useReducer, useContext } from 'react';
import { reducer } from './Reducer';

export const StoreContext = createContext();

const initialState = {
  programas: [],
  loading: false,
  error: null,
  loadingLogin: false,
  errorLogin: null,
  user: null,
  menuAdminActivo: null,
  programaSelected: null,
  loadingPrograma: false,
  loadingImage: false,
  uploadedImage: null
};

export function StoreProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
}

export const useStore = () => useContext(StoreContext);
